export type CaptureLedgerDisposition =
  | "empty"
  | "complete"
  | "asymmetric";

export function captureLedgerDisposition(
  sourceChunks: number,
  analysisChunks: number
): CaptureLedgerDisposition {
  if (sourceChunks === 0 && analysisChunks === 0) return "empty";
  if (sourceChunks > 0 && analysisChunks > 0) return "complete";
  return "asymmetric";
}

export function canRequestCaptureSeal(input: {
  readonly pendingStop: boolean;
  readonly stopSent: boolean;
  readonly producersQuiesced: boolean;
  readonly socketOpen: boolean;
}): boolean {
  return (
    input.pendingStop &&
    !input.stopSent &&
    input.producersQuiesced &&
    input.socketOpen
  );
}
